var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgZoomPlus = function SvgZoomPlus(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.1 654.9c-128-128-128-336.8 0-464.8s336.8-128 464.8 0 128 336.8 0 464.8-336.8 128-464.8 0m789.8 217.7-216.2-203c119.2-164.7 105.9-397.1-42.6-545.7-164.7-164.7-432.4-164.7-597.2 0-164.7 164.7-164.7 432.4 0 597.2 148.6 148.6 380.9 161.8 545.7 42.6l217.7 203c26.5 26.5 67.7 26.5 94.1 0 25-26.5 25-67.6-1.5-94.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M590.2 373.9H472.5V256.3c0-26.5-22.1-50-50-50-26.5 0-50 22.1-50 50V374H254.8c-26.5 0-50 22.1-50 50 0 26.5 22.1 50 50 50h117.7v117.7c0 26.5 22.1 50 50 50 26.5 0 50-22.1 50-50V473.9h117.7c26.5 0 50-22.1 50-50-1.5-27.9-23.6-50-50-50"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgZoomPlus);
export default ForwardRef;